import { render, staticRenderFns } from "./TodoDetailContact.vue?vue&type=template&id=e2046404&scoped=true&"
import script from "./TodoDetailContact.vue?vue&type=script&lang=ts&"
export * from "./TodoDetailContact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2046404",
  null
  
)

export default component.exports